module.exports = __webpack_public_path__ + "static/media/tick.a34c00f1.svg";